import React from "react"
import Collapsible from "react-collapsible"

import { Wrapper } from "./style"

function Faq() {
  return (
    <div className="faq">
      <Wrapper>
        {FAQS.map(({ title, content }) => (
          <Collapsible
            className="faq-item"
            openedClassName="faq-item active"
            triggerClassName="faq-title"
            triggerOpenedClassName="faq-title active"
            triggerTagName="button"
            contentInnerClassName="faq-content"
            trigger={title}
            transitionTime={200}
            easing="ease-out"
            key={title}
          >
            {content()}
          </Collapsible>
        ))}
      </Wrapper>
    </div>
  )
}

const FAQS = [
  {
    title: "What kind of students do we look to recruit?",
    content: () => (
      <>
        We look for individuals who are passionate about creating change and
        impact in our community. Our members tend to have leadership, critical
        thinking skills, and a passion to learn and grow as well as a desire to
        take initiative in the community. Finally, we look for individuals who
        are enthusiastic about working on a team and connecting with our current
        members!
      </>
    ),
  },
  {
    title:
      "How much consulting experience is required? Is there a minimum GPA?",
    content: () => (
      <>
        We understand that every student may have varying levels of professional
        experience. Therefore, no prior consulting or business experience is
        required. There is no minimum GPA requirement and we encourage every
        major to join! We believe that every student has strengths that they can
        contribute to our team and have members from a variety of different
        backgrounds!
      </>
    ),
  },
  {
    title: "What does the recruitment and interview process involve?",
    content: () => (
      <>
        In order to best understand our applicants, our recruitment process is
        divided into three parts: an application, a group interview, and a final
        individual interview.
      </>
    ),
  },
  {
    title: "How do I prepare for the interviews?",
    content: () => (
      <>
        While seemingly intimidating, case interviews let us best understand
        your business acumen and critical thinking. We understand that most of
        our applicants will have little to no experience with our case
        interviews and will therefore provide you with several case study
        materials before the interview. In the meantime, we encourage you to
        research casing online and to practice some math problems beforehand.
      </>
    ),
  },
  {
    title: "What's different about the final interview in 2021?",
    content: () => (
      <>
        Starting in the Winter 2021 recruitment cycle, our final round of
        individual interviews will now consist of a short presentation from the
        applicant instead of a traditional case interview. The presentation will
        be focused on a business or health-related topic and the applicant will
        be tasked with developing basic solutions. This presentation allows the
        applicant to show CYC their skill set in a more consulting-oriented
        setting than a traditional case interview. The materials and prompt for
        the presentation will be provided with adequate time for the applicant
        to prepare and practice the presentation before their interview. The
        presentation should be approximately 3-5 slides, last less than 10
        minutes, and should take the applicant less than an hour to create.
      </>
    ),
  },
]

export default Faq
